import _extends from "@babel/runtime-corejs3/helpers/extends";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React, { useRef, useImperativeHandle, useEffect, forwardRef } from 'react';
import Downshift from '@rexlabs/downshift';
import Box from '@rexlabs/box';
import { useDownshiftContext } from '../../../../core';
import DefaultValue from '../../../shared/components/defaults/value';
var TagSingleSelectInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _selectedItem$Value;

  var disabled = _ref.disabled,
      innerRef = _ref.innerRef,
      Value = _ref.Value,
      props = _objectWithoutProperties(_ref, ["disabled", "innerRef", "Value"]);

  var _useDownshiftContext = useDownshiftContext(),
      selectedItem = _useDownshiftContext.selectedItem,
      setStateChangeAction = _useDownshiftContext.setStateChangeAction;

  var tagRef = useRef(null);
  var inputRef = useRef(null); // Make sure the external ref can use it normally

  useImperativeHandle(ref, function () {
    return inputRef.current;
  }, []); // HACK: Really need to revisit this
  // The problem with just changing the focus states
  // in a useLayoutEffect when selectedItem changes is
  // that this doesn't account for external changes
  // (like a form imperatively updating the select state)
  // This gets around the issue by hooking into the
  // onStateChange function passed to the select and
  // only focusing the input specifically when we want to
  // based on user actions
  // We need the timeout because this is run within downshift
  // at _some point_ so we don't know when either the value
  // or the input is going to be rendered

  useEffect(function () {
    setStateChangeAction('setInputFocus', function (changes) {
      if (changes.hasOwnProperty('selectedItem')) {
        switch (changes.type) {
          case Downshift.stateChangeTypes.unknown:
            if (!changes.selectedItem) {
              _setTimeout(function () {
                var _inputRef$current, _inputRef$current$foc;

                return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : (_inputRef$current$foc = _inputRef$current.focus) === null || _inputRef$current$foc === void 0 ? void 0 : _inputRef$current$foc.call(_inputRef$current);
              });
            }

        }
      }
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputRef]); // Same goes for this

  useEffect(function () {
    setStateChangeAction('setTagButtonFocus', function (changes) {
      if (changes.hasOwnProperty('selectedItem')) {
        switch (changes.type) {
          case Downshift.stateChangeTypes.keyDownEnter:
          case Downshift.stateChangeTypes.clickItem:
            if (changes.selectedItem) {
              _setTimeout(function () {
                var _tagRef$current, _tagRef$current$query, _tagRef$current$query2;

                return (_tagRef$current = tagRef.current) === null || _tagRef$current === void 0 ? void 0 : (_tagRef$current$query = _tagRef$current.querySelector('button')) === null || _tagRef$current$query === void 0 ? void 0 : (_tagRef$current$query2 = _tagRef$current$query.focus) === null || _tagRef$current$query2 === void 0 ? void 0 : _tagRef$current$query2.call(_tagRef$current$query);
              });
            }

        }
      }
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagRef]);
  var RenderValue = (_selectedItem$Value = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.Value) !== null && _selectedItem$Value !== void 0 ? _selectedItem$Value : Value;
  return /*#__PURE__*/React.createElement(Box, {
    style: {
      overflow: 'hidden'
    },
    flex: 1
  }, selectedItem ? /*#__PURE__*/React.createElement(DefaultValue, {
    fullWidth: true,
    tagRef: tagRef,
    disabled: disabled,
    item: selectedItem,
    Value: RenderValue
  }) : /*#__PURE__*/React.createElement("input", _extends({
    ref: inputRef
  }, props, {
    disabled: disabled
  })));
});
TagSingleSelectInput.displayName = 'TagSingleSelectInput';
export default TagSingleSelectInput;